/* Embroidery Inc logo handoff v1 (2026-10-21), theme side. Spec: .redesign-work/industry-pages-2026-10/LOGO-HANDOFF.md
   One shared module for the header "Upload logo" button + chip and the crew kit builder (assets/ei-kit.js).
   - Storage: localStorage["ei-logo:v1"] = {"v":1,"url","name","w","h","ts","src"}, valid 30 days, url must match the
     contract setup-line image pattern. Invalid or expired records are removed. Every storage call is in try/catch.
   - Upload: same unsigned Cloudinary request as the cart (FormData file, cloud_name, upload_preset; values from
     window.__eiCartConfig with the cart's constants as fallback), 25 MB guard, progress, retry.
   - Events: dispatches ei:logo:offer {url,name,src} only after a successful upload; listens to ei:logo:changed.
   - Privacy: never logs or sends the url or file name anywhere; every element showing them has ph-no-capture.
   - Never defines window.__eiCart and never touches #cart-icon-bubble. Exposes window.__eiLogo. */
(function () {
  'use strict';
  if (window.__eiLogo) return;

  var KEY = 'ei-logo:v1';
  var TTL = 30 * 24 * 60 * 60 * 1000;
  var MAX = 25 * 1024 * 1024;
  var ACCEPT = '.png,.jpg,.jpeg,.svg,.pdf,.ai,.eps';
  var EXTS = ['png', 'jpg', 'jpeg', 'svg', 'pdf', 'ai', 'eps'];
  var RASTER = ['png', 'jpg', 'jpeg', 'gif', 'webp'];
  var PATTERN = /^https:\/\/res\.cloudinary\.com\/hatsemb-com\/image\/upload\/v[0-9]{10}\/[a-z0-9]{20}\.[a-z0-9]+$/;
  var TERMS = '/policies/terms-of-service';

  var T = {
    drop: 'Drop your logo here or',
    choose: 'choose a file',
    chooseTouch: 'Choose a file or photo',
    formats: 'PNG, JPG, SVG, PDF, AI or EPS, up to 25 MB.',
    uploading: function (p) { return 'Uploading ' + p + '%'; },
    progress: 'Upload progress',
    cancel: 'Cancel',
    done: 'Uploaded',
    replace: 'Replace',
    retry: 'Try again',
    other: 'Choose a different file',
    decl: 'By uploading, you confirm you own this artwork or have permission to use it. See our',
    terms: 'Terms of Service',
    err: {
      network: "That upload didn't go through. Check your connection and try again.",
      size: 'That file is over 25 MB. Try a smaller copy.',
      type: "We can't use that file type. Try a PNG, JPG, SVG, PDF, AI or EPS.",
      empty: 'That file looks empty. Try another copy.'
    },
    unsaved: "It uploaded, but we couldn't save it for your cart. Please upload it again in the cart.",
    liveStart: 'Uploading your logo.',
    liveHalf: 'Halfway there.',
    liveDone: 'Logo uploaded.',
    thumbAlt: 'Your logo',
    yourLogo: 'Your logo',
    dlgTitle: 'Upload your logo',
    dlgTitleChange: 'Change your logo',
    dlgLede: "Add it once and it'll be waiting in your cart. We stitch a real proof on a test hat, and you approve it before we make the rest.",
    okAuto: "Saved. We'll add it to your cart for you.",
    okManual: "Saved. You'll confirm it in your cart.",
    okNote: 'We keep it in this browser for 30 days.',
    shopHats: 'Shop hats',
    goCart: 'Go to cart',
    finish: 'Done',
    close: 'Close',
    menuNote: 'Saved in this browser for 30 days.',
    change: 'Change logo',
    remove: 'Remove',
    removed: 'Logo removed from this browser. Your cart is unchanged.',
    chipLabel: 'Your logo. Show options',
    drawerSaved: 'Saved for your cart'
  };

  var ICON = {
    upload: '<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><path d="M17 8l-5-5-5 5"/><path d="M12 3v12"/>',
    file: '<path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z"/><path d="M14 3v5h5"/>',
    check: '<path d="M5 12.5l4.5 4.5L19 7.5"/>',
    alert: '<circle cx="12" cy="12" r="9"/><path d="M12 7.5v5.5"/><path d="M12 16.5h.01"/>',
    close: '<path d="M6 6l12 12M18 6L6 18"/>',
    down: '<path d="M6 9l6 6 6-6"/>'
  };
  function icon(n, cls) {
    return '<svg class="ei-lg-ic' + (cls ? ' ' + cls : '') + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + ICON[n] + '</svg>';
  }

  /* ---------------- tiny DOM helper ---------------- */
  function h(tag, attrs, kids) {
    var el = document.createElement(tag);
    if (attrs) {
      for (var k in attrs) {
        if (!Object.prototype.hasOwnProperty.call(attrs, k) || attrs[k] == null || attrs[k] === false) continue;
        if (k === 'text') el.textContent = attrs[k];
        else if (k === 'html') el.innerHTML = attrs[k];
        else if (k === 'class') el.className = attrs[k];
        else if (k.slice(0, 2) === 'on' && typeof attrs[k] === 'function') el.addEventListener(k.slice(2), attrs[k]);
        else el.setAttribute(k, attrs[k] === true ? '' : attrs[k]);
      }
    }
    (kids || []).forEach(function (c) { if (c != null) el.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return el;
  }
  var uid = 0;
  function nextId(p) { uid += 1; return (p || 'ei-lg') + '-' + uid; }

  /* ---------------- storage ---------------- */
  function valid(url) { return typeof url === 'string' && PATTERN.test(url); }
  function okRecord(r) {
    return !!r && r.v === 1 && valid(r.url) && typeof r.ts === 'number' && isFinite(r.ts) && Date.now() - r.ts < TTL;
  }
  function read() {
    var raw = null;
    try { raw = window.localStorage.getItem(KEY); } catch (e) { return null; }
    if (raw == null) return null;
    var r = null;
    try { r = JSON.parse(raw); } catch (e) { r = null; }
    if (okRecord(r)) return r;
    try { window.localStorage.removeItem(KEY); } catch (e) { /* storage blocked */ }
    return null;
  }
  function int(n) { n = Number(n); return isFinite(n) && n > 0 ? Math.round(n) : null; }
  function write(x) {
    if (!x || !valid(x.url)) return null;
    var rec = {
      v: 1,
      url: x.url,
      name: String(x.name || '').slice(0, 80),
      w: int(x.w),
      h: int(x.h),
      ts: Date.now(),
      src: x.src === 'kit' || x.src === 'cart' ? x.src : 'header'
    };
    try { window.localStorage.setItem(KEY, JSON.stringify(rec)); } catch (e) { return null; }
    return rec;
  }
  function clear() { try { window.localStorage.removeItem(KEY); } catch (e) { /* storage blocked */ } }

  /* ---------------- files + urls ---------------- */
  function ext(s) {
    var m = /\.([a-z0-9]{1,5})(?:$|[?#])/i.exec(String(s || ''));
    return m ? m[1].toLowerCase() : '';
  }
  function isRaster(e) { return RASTER.indexOf(e) > -1 || e === 'svg'; }
  /* Small Cloudinary rendition for display only (the order always uses the original url).
     Vector and document formats are asked for as PNG; the <img> falls back to a file icon if that fails. */
  function thumb(url, px) {
    var m = /^(https:\/\/res\.cloudinary\.com\/[a-z0-9-]+\/image\/upload\/)(v[0-9]+\/[^?#]+)$/i.exec(String(url || ''));
    if (!m) return url;
    var rest = m[2];
    if (RASTER.indexOf(ext(rest)) < 0) rest = rest.replace(/\.[a-z0-9]+$/i, '.png');
    return m[1] + 'c_limit,w_' + px + ',h_' + px + '/' + rest;
  }
  function check(file) {
    if (!file) return 'type';
    if (EXTS.indexOf(ext(file.name)) < 0) return 'type';
    if (!file.size) return 'empty';
    if (file.size > MAX) return 'size';
    return null;
  }
  function conf() {
    var c = window.__eiCartConfig || {};
    var cloud = typeof c.cloudName === 'string' && c.cloudName ? c.cloudName : 'hatsemb-com';
    var preset = typeof c.uploadPreset === 'string' && c.uploadPreset ? c.uploadPreset : 'shopify_draft_order_images';
    var url = typeof c.uploadUrl === 'string' && c.uploadUrl ? c.uploadUrl : 'https://api.cloudinary.com/v1_1/' + cloud + '/upload';
    return { cloud: cloud, preset: preset, url: url };
  }
  function terms() {
    var c = window.__eiCartConfig;
    return (c && c.ui && typeof c.ui.termsUrl === 'string' && c.ui.termsUrl) || TERMS;
  }

  /* Same request as the cart engine (cart-app/src/engine/upload.ts): FormData file, cloud_name, upload_preset. */
  function upload(file, onProgress) {
    var c = conf();
    var xhr = null;
    var aborted = false;
    var promise = new Promise(function (resolve) {
      try {
        xhr = new XMLHttpRequest();
        xhr.open('POST', c.url);
        xhr.timeout = 120000;
        if (xhr.upload) {
          xhr.upload.onprogress = function (e) {
            if (e.lengthComputable && onProgress) onProgress(e.total > 0 ? Math.min(1, e.loaded / e.total) : 0);
          };
        }
        xhr.onload = function () {
          var j = null;
          try { j = JSON.parse(xhr.responseText || ''); } catch (e) { j = null; }
          if (xhr.status < 200 || xhr.status >= 300) { resolve({ ok: false, code: 'http', status: xhr.status }); return; }
          var url = j && j.secure_url;
          if (typeof url !== 'string' || !url) { resolve({ ok: false, code: 'no_url', status: xhr.status }); return; }
          if (url.indexOf('https://res.cloudinary.com/' + c.cloud + '/') !== 0) { resolve({ ok: false, code: 'bad_url', status: xhr.status }); return; }
          resolve({ ok: true, url: url, w: int(j.width), h: int(j.height), storable: valid(url) });
        };
        xhr.onerror = function () { resolve({ ok: false, code: 'network', status: 0 }); };
        xhr.ontimeout = function () { resolve({ ok: false, code: 'timeout', status: 0 }); };
        xhr.onabort = function () { resolve({ ok: false, code: aborted ? 'aborted' : 'network', status: 0 }); };
        var fd = new FormData();
        fd.append('file', file);
        fd.append('cloud_name', c.cloud);
        fd.append('upload_preset', c.preset);
        xhr.send(fd);
      } catch (e) {
        resolve({ ok: false, code: 'network', status: 0 });
      }
    });
    return { promise: promise, abort: function () { aborted = true; try { if (xhr) xhr.abort(); } catch (e) { /* ignore */ } } };
  }

  function handoff() { var c = window.__eiCart; return !!(c && c.logoHandoff === 1); }
  function offer(rec) {
    if (!rec || !valid(rec.url)) return;
    try {
      window.dispatchEvent(new CustomEvent('ei:logo:offer', { detail: { url: rec.url, name: rec.name || '', src: rec.src || 'header' } }));
    } catch (e) { /* old browser */ }
  }

  /* Thumbnail element: image for anything Cloudinary can render, a file badge otherwise. */
  function thumbEl(url, name, px, cls) {
    var box = h('span', { class: 'ei-lg-th ph-no-capture' + (cls ? ' ' + cls : '') });
    var e = ext(url) || ext(name);
    var badge = h('span', { class: 'ei-lg-th__f', html: icon('file') + '<b>' + (e ? e.toUpperCase().slice(0, 4) : '') + '</b>' });
    if (url) {
      var img = h('img', { src: thumb(url, px), alt: T.thumbAlt, width: String(px / 2), height: String(px / 2), decoding: 'async' });
      img.addEventListener('error', function () { img.remove(); box.classList.add('is-file'); });
      box.appendChild(img);
    } else {
      box.classList.add('is-file');
    }
    box.appendChild(badge);
    return box;
  }

  /* ---------------- uploader component (header modal + kit builder) ---------------- */
  function Uploader(opts) {
    opts = opts || {};
    var touch = !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
    var st = { status: 'idle', pct: 0, name: '', url: null, w: null, h: null, code: null, storable: true };
    var handle = null;
    var lastFile = null;
    var half = false;
    var errId = nextId('ei-lg-err');

    var input = h('input', { type: 'file', accept: ACCEPT, class: 'ei-lg-vh', tabindex: '-1', 'aria-hidden': 'true' });
    var live = h('div', { class: 'ei-lg-vh', 'aria-live': 'polite', 'aria-atomic': 'true' });
    var root = h('div', { class: 'ei-lg-up ph-no-capture', 'data-state': 'idle' });
    var zone = h('div', { class: 'ei-lg-zone' });
    var box = h('div', { class: 'ei-lg-file', hidden: true });
    var err = h('div', { class: 'ei-lg-err', id: errId, role: 'alert', hidden: true });
    var foot = h('p', { class: 'ei-lg-decl' }, [T.decl + ' ', h('a', { href: terms(), target: '_blank', rel: 'noopener', text: T.terms }), '.']);
    var chooseBtn;

    if (touch) {
      chooseBtn = h('button', { type: 'button', class: 'ei-lg-btn ei-lg-btn--primary ei-lg-btn--block', html: icon('upload') + '<span>' + T.chooseTouch + '</span>' });
      zone.appendChild(chooseBtn);
      zone.appendChild(h('p', { class: 'ei-lg-fmt', text: T.formats }));
      zone.classList.add('ei-lg-zone--touch');
    } else {
      chooseBtn = h('button', { type: 'button', class: 'ei-lg-link', text: T.choose });
      zone.appendChild(h('span', { class: 'ei-lg-zone__ic', html: icon('upload') }));
      zone.appendChild(h('p', { class: 'ei-lg-zone__t' }, [T.drop + ' ', chooseBtn]));
      zone.appendChild(h('p', { class: 'ei-lg-fmt', text: T.formats }));
      zone.addEventListener('click', function (e) { if (!e.target.closest('button,a') && st.status !== 'uploading') pick(); });
      zone.addEventListener('dragover', function (e) { e.preventDefault(); zone.classList.add('is-over'); });
      zone.addEventListener('dragleave', function () { zone.classList.remove('is-over'); });
      zone.addEventListener('drop', function (e) {
        e.preventDefault();
        zone.classList.remove('is-over');
        var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
        if (f) start(f);
      });
    }
    chooseBtn.addEventListener('click', pick);
    input.addEventListener('change', function () {
      var f = input.files && input.files[0];
      input.value = '';
      if (f) start(f);
    });
    root.appendChild(zone);
    root.appendChild(box);
    root.appendChild(err);
    root.appendChild(input);
    root.appendChild(live);
    root.appendChild(foot);

    function say(s) { live.textContent = ''; window.setTimeout(function () { live.textContent = s; }, 30); }
    function pick() { try { input.click(); } catch (e) { /* ignore */ } }
    function emit() { if (opts.onChange) opts.onChange(state()); }
    function state() { return { status: st.status, pct: st.pct, name: st.name, url: st.url, w: st.w, h: st.h, code: st.code, storable: st.storable }; }

    function paint() {
      var had = root.contains(document.activeElement);
      paintInner();
      if (had && !root.contains(document.activeElement)) {
        var f = root.querySelector('.ei-lg-file:not([hidden]) button, .ei-lg-err:not([hidden]) button, .ei-lg-zone:not([hidden]) button');
        if (f) f.focus({ preventScroll: true });
      }
    }
    function paintInner() {
      root.setAttribute('data-state', st.status);
      zone.hidden = st.status === 'uploading' || st.status === 'done';
      box.hidden = !(st.status === 'uploading' || st.status === 'done');
      err.hidden = st.status !== 'error';
      box.innerHTML = '';
      err.innerHTML = '';
      if (st.status === 'uploading' || st.status === 'done') {
        var done = st.status === 'done';
        box.appendChild(done ? thumbEl(st.url, st.name, 128, 'ei-lg-th--m') : thumbEl(null, st.name, 128, 'ei-lg-th--m'));
        var body = h('div', { class: 'ei-lg-file__b' });
        if (done) body.appendChild(h('p', { class: 'ei-lg-ok', html: icon('check') + '<span>' + T.done + '</span>' }));
        body.appendChild(h('p', { class: 'ei-lg-file__n', text: st.name || T.yourLogo }));
        if (!done) {
          var bar = h('div', { class: 'ei-lg-bar', role: 'progressbar', 'aria-label': T.progress, 'aria-valuemin': '0', 'aria-valuemax': '100', 'aria-valuenow': String(st.pct) }, [h('span', { style: 'width:' + st.pct + '%' })]);
          body.appendChild(bar);
          body.appendChild(h('p', { class: 'ei-lg-small', text: T.uploading(st.pct) }));
        }
        if (done && !st.storable) body.appendChild(h('p', { class: 'ei-lg-small ei-lg-warn', text: T.unsaved }));
        body.appendChild(h('button', {
          type: 'button',
          class: 'ei-lg-link',
          text: done ? T.replace : T.cancel,
          onclick: done ? pick : cancel
        }));
        box.appendChild(body);
      }
      if (st.status === 'error') {
        err.appendChild(h('p', { html: icon('alert') + '<span></span>' }));
        err.querySelector('span').textContent = T.err[st.code] || T.err.network;
        var acts = h('div', { class: 'ei-lg-err__a' });
        if (lastFile && (st.code === 'network')) acts.appendChild(h('button', { type: 'button', class: 'ei-lg-link', text: T.retry, onclick: function () { start(lastFile); } }));
        acts.appendChild(h('button', { type: 'button', class: 'ei-lg-link', text: T.other, onclick: pick }));
        err.appendChild(acts);
      }
    }
    function setBar() {
      var bar = box.querySelector('.ei-lg-bar');
      if (!bar) return;
      bar.setAttribute('aria-valuenow', String(st.pct));
      bar.firstChild.style.width = st.pct + '%';
      var s = box.querySelector('.ei-lg-small');
      if (s) s.textContent = T.uploading(st.pct);
    }
    function fail(code) {
      st = { status: 'error', pct: 0, name: st.name, url: null, w: null, h: null, code: code, storable: true };
      paint();
      emit();
    }
    function cancel() {
      if (handle) { var x = handle; handle = null; x.abort(); }
      st = { status: 'idle', pct: 0, name: '', url: null, w: null, h: null, code: null, storable: true };
      paint();
      emit();
      chooseBtn.focus();
    }
    function start(file) {
      var bad = check(file);
      lastFile = file;
      st.name = String(file && file.name || '').slice(0, 80);
      if (bad) { fail(bad); return; }
      if (handle) handle.abort();
      st = { status: 'uploading', pct: 0, name: st.name, url: null, w: null, h: null, code: null, storable: true };
      half = false;
      paint();
      emit();
      say(T.liveStart);
      var mine = upload(file, function (p) {
        if (handle !== mine) return;
        st.pct = Math.round(p * 100);
        setBar();
        if (!half && st.pct >= 50) { half = true; say(T.liveHalf); }
      });
      handle = mine;
      mine.promise.then(function (res) {
        if (handle !== mine) return;
        handle = null;
        if (res.code === 'aborted') return;
        if (!res.ok) { fail('network'); return; }
        st = { status: 'done', pct: 100, name: st.name, url: res.url, w: res.w, h: res.h, code: null, storable: !!res.storable };
        paint();
        say(T.liveDone);
        emit();
        if (opts.onDone) opts.onDone(state());
      });
    }
    function reset() {
      if (handle) { var x = handle; handle = null; x.abort(); }
      st = { status: 'idle', pct: 0, name: '', url: null, w: null, h: null, code: null, storable: true };
      lastFile = null;
      paint();
    }
    paint();
    return {
      el: root,
      state: state,
      reset: reset,
      focus: function () { var b = root.querySelector('button:not([hidden])'); if (b) b.focus(); },
      busy: function () { return st.status === 'uploading'; }
    };
  }

  /* ---------------- header: slots, chip, popover, upload dialog ---------------- */
  var dlg = null;
  var dlgUp = null;
  var dlgOpener = null;
  var pop = null;
  var popOpener = null;
  var popAt = null;
  var announcer = null;

  function announce(s) {
    if (!announcer) {
      announcer = h('div', { class: 'ei-lg-vh', 'aria-live': 'polite', 'aria-atomic': 'true' });
      document.body.appendChild(announcer);
    }
    announcer.textContent = '';
    window.setTimeout(function () { announcer.textContent = s; }, 30);
  }

  function render(rec) {
    if (rec === undefined) rec = read();
    var on = !!(rec && valid(rec.url));
    document.documentElement.classList.toggle('ei-lg-on', on);
    var imgs = document.querySelectorAll('[data-ei-logo-img]');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      var px = parseInt(img.getAttribute('data-ei-logo-img'), 10) || 64;
      var box = img.parentNode;
      if (!on) { img.removeAttribute('src'); continue; }
      var want = thumb(rec.url, px);
      if (img.getAttribute('src') !== want) {
        if (box) box.classList.remove('is-file');
        img.setAttribute('src', want);
      }
      if (!img.__eiErr) {
        img.__eiErr = true;
        img.addEventListener('error', function () { if (this.parentNode) this.parentNode.classList.add('is-file'); });
        if (img.complete && img.naturalWidth === 0 && img.getAttribute('src') && box) box.classList.add('is-file');
      }
    }
    var names = document.querySelectorAll('[data-ei-logo-name]');
    for (var j = 0; j < names.length; j++) names[j].textContent = on ? (rec.name || T.yourLogo) : '';
    var exts = document.querySelectorAll('[data-ei-logo-ext]');
    for (var k = 0; k < exts.length; k++) exts[k].textContent = on ? ext(rec.url).toUpperCase().slice(0, 4) : '';
    if (!on) closePop(false);
  }

  function visibleFirst(sel) {
    var all = document.querySelectorAll(sel);
    for (var i = 0; i < all.length; i++) if (all[i].offsetParent !== null) return all[i];
    return null;
  }
  function cartCount() {
    var n = document.querySelector('#cart-icon-bubble .header__cart-count-number');
    var v = n ? parseInt(n.textContent, 10) : 0;
    return isFinite(v) ? v : 0;
  }

  function lockScroll(on) { document.documentElement.classList.toggle('ei-lg-lock', on); }

  function buildDialog() {
    var tid = nextId('ei-lg-dlg-t');
    dlg = h('dialog', { class: 'ei-lg-dlg ph-no-capture', 'aria-labelledby': tid });
    var x = h('button', { type: 'button', class: 'ei-lg-x', 'aria-label': T.close, html: icon('close') });
    var title = h('h2', { class: 'ei-lg-dlg__t', id: tid, tabindex: '-1', text: T.dlgTitle });
    var lede = h('p', { class: 'ei-lg-dlg__l', text: T.dlgLede });
    var ok = h('div', { class: 'ei-lg-dlg__ok', hidden: true });
    var acts = h('div', { class: 'ei-lg-dlg__a', hidden: true });
    dlgUp = Uploader({
      src: 'header',
      onDone: function (s) {
        if (!s.url) return;
        var rec = s.storable ? write({ url: s.url, name: s.name, w: s.w, h: s.h, src: 'header' }) : null;
        if (rec) {
          offer(rec);
          render(rec);
        }
        ok.innerHTML = '';
        if (rec || s.storable) {
          ok.appendChild(h('p', { class: 'ei-lg-dlg__okt', html: icon('check') + '<span></span>' }));
          ok.querySelector('span').textContent = rec ? (handoff() ? T.okAuto : T.okManual) : T.okManual;
          if (rec) ok.appendChild(h('p', { class: 'ei-lg-small', text: T.okNote }));
        }
        ok.hidden = !rec;
        acts.innerHTML = '';
        var n = cartCount();
        acts.appendChild(h('a', { class: 'ei-lg-btn ei-lg-btn--ghost', href: n > 0 ? '/cart' : '/collections/custom-embroidered-hats', text: n > 0 ? T.goCart : T.shopHats }));
        var fin = h('button', { type: 'button', class: 'ei-lg-btn ei-lg-btn--primary', text: T.finish, onclick: function () { dlg.close(); } });
        acts.appendChild(fin);
        acts.hidden = false;
        fin.focus();
      }
    });
    var box = h('div', { class: 'ei-lg-dlg__box' }, [x, title, lede, dlgUp.el, ok, acts]);
    dlg.appendChild(box);
    x.addEventListener('click', function () { dlg.close(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    dlg.addEventListener('close', function () {
      lockScroll(false);
      var o = dlgOpener;
      dlgOpener = null;
      if (o && document.contains(o) && o.offsetParent !== null) o.focus({ preventScroll: true });
      else {
        var any = visibleFirst('.header [data-ei-logo-chip], .header [data-ei-logo-open]');
        if (any) any.focus({ preventScroll: true });
      }
    });
    dlg.__title = title;
    dlg.__ok = ok;
    dlg.__acts = acts;
    document.body.appendChild(dlg);
  }

  function openDialog(opener, change) {
    closePop(false);
    if (!dlg) buildDialog();
    if (typeof dlg.showModal !== 'function') return false;
    if (dlg.open) return true;
    if (!dlgUp.busy()) dlgUp.reset();
    dlg.__ok.hidden = true;
    dlg.__acts.hidden = true;
    dlg.__title.textContent = change ? T.dlgTitleChange : T.dlgTitle;
    dlgOpener = opener || null;
    dlg.showModal();
    lockScroll(true);
    dlgUp.focus();
    return true;
  }

  /* Popover menu under the chip: preview, name, Change logo, Remove. */
  function closePop(refocus) {
    if (!pop || pop.hidden) return;
    pop.hidden = true;
    popAt = null;
    if (popOpener) {
      popOpener.setAttribute('aria-expanded', 'false');
      if (refocus) popOpener.focus({ preventScroll: true });
    }
    popOpener = null;
  }
  function openPop(chip) {
    var rec = read();
    if (!rec) { render(null); return; }
    if (!pop) {
      pop = h('div', { class: 'ei-lg-pop ph-no-capture', id: 'ei-lg-pop', role: 'dialog', 'aria-label': T.yourLogo, hidden: true });
      document.body.appendChild(pop);
      pop.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { e.preventDefault(); closePop(true); }
        if (e.key === 'Tab') {
          var f = pop.querySelectorAll('button');
          if (!f.length) return;
          var first = f[0], last = f[f.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      });
    }
    pop.innerHTML = '';
    pop.appendChild(h('div', { class: 'ei-lg-pop__top' }, [
      thumbEl(rec.url, rec.name, 160, 'ei-lg-th--l'),
      h('div', { class: 'ei-lg-pop__b' }, [
        h('p', { class: 'ei-lg-pop__k', text: T.yourLogo }),
        h('p', { class: 'ei-lg-pop__n', text: rec.name || T.yourLogo }),
        h('p', { class: 'ei-lg-small', text: T.menuNote })
      ])
    ]));
    var change = h('button', { type: 'button', class: 'ei-lg-btn ei-lg-btn--primary ei-lg-btn--block', text: T.change });
    var rm = h('button', { type: 'button', class: 'ei-lg-btn ei-lg-btn--ghost ei-lg-btn--block', text: T.remove });
    change.addEventListener('click', function () { var o = popOpener; closePop(false); openDialog(o, true); });
    rm.addEventListener('click', function () {
      clear();
      closePop(false);
      render(null);
      announce(T.removed);
      var b = visibleFirst('.header [data-ei-logo-open]');
      if (b) b.focus({ preventScroll: true });
    });
    pop.appendChild(h('div', { class: 'ei-lg-pop__a' }, [change, rm]));
    var r = chip.getBoundingClientRect();
    pop.hidden = false;
    var w = pop.offsetWidth;
    var left = Math.max(8, Math.min(window.innerWidth - w - 8, r.right - w));
    pop.style.top = Math.round(r.bottom + 8) + 'px';
    pop.style.left = Math.round(left) + 'px';
    popOpener = chip;
    popAt = { y: window.scrollY, w: window.innerWidth };
    chip.setAttribute('aria-expanded', 'true');
    change.focus({ preventScroll: true });
  }

  function closeDrawerThen(fn) {
    var d = document.querySelector('main-menu .main-menu__disclosure');
    var t = document.querySelector('main-menu .main-menu__toggle');
    if (d && t && (d.open || d.classList.contains('is-open'))) {
      t.click();
      window.setTimeout(fn, 320);
    } else fn();
  }

  function onClick(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var open = t.closest('[data-ei-logo-open]');
    if (open) {
      if (e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault();
      var change = open.hasAttribute('data-ei-logo-change');
      if (open.closest('.ei-drawer-extra')) {
        var chip = document.querySelector('.ei-lg-slot--m [data-ei-logo-open], .ei-lg-slot--m [data-ei-logo-chip]');
        closeDrawerThen(function () { openDialog(chip && chip.offsetParent !== null ? chip : null, change); });
      } else {
        openDialog(open, change);
      }
      return;
    }
    var chipBtn = t.closest('[data-ei-logo-chip]');
    if (chipBtn) {
      e.preventDefault();
      if (pop && !pop.hidden && popOpener === chipBtn) closePop(true);
      else openPop(chipBtn);
      return;
    }
    var rmBtn = t.closest('[data-ei-logo-remove]');
    if (rmBtn) {
      e.preventDefault();
      clear();
      render(null);
      announce(T.removed);
      return;
    }
    if (pop && !pop.hidden && !pop.contains(t)) closePop(false);
  }
  function onKey(e) {
    var t = e.target;
    if ((e.key === ' ' || e.key === 'Spacebar') && t && t.matches && t.matches('a[data-ei-logo-open]')) {
      e.preventDefault();
      t.click();
    }
  }

  function initHeader() {
    var links = document.querySelectorAll('a[data-ei-logo-open]');
    for (var i = 0; i < links.length; i++) {
      links[i].setAttribute('role', 'button');
      links[i].setAttribute('aria-haspopup', 'dialog');
    }
    render();
  }

  document.addEventListener('click', onClick);
  document.addEventListener('keydown', onKey);
  /* Phones fire scroll + resize when the URL bar slides; only a real scroll or a width change closes the menu. */
  window.addEventListener('resize', function () { if (popAt && window.innerWidth !== popAt.w) closePop(false); });
  window.addEventListener('scroll', function () { if (popAt && Math.abs(window.scrollY - popAt.y) > 48) closePop(false); }, { passive: true });
  window.addEventListener('ei:logo:changed', function (e) {
    var d = (e && e.detail) || {};
    if (d.url && valid(d.url)) {
      var cur = read();
      render(cur && cur.url === d.url ? cur : { v: 1, url: d.url, name: d.name || '', ts: Date.now() });
    } else {
      render();
    }
  });
  window.addEventListener('storage', function (e) { if (!e || e.key === KEY || e.key === null) render(); });
  window.addEventListener('pageshow', function (e) { if (e && e.persisted) render(); });

  window.__eiLogo = Object.freeze({
    KEY: KEY,
    ACCEPT: ACCEPT,
    MAX: MAX,
    read: read,
    write: write,
    clear: clear,
    valid: valid,
    thumb: thumb,
    ext: ext,
    isRaster: isRaster,
    check: check,
    upload: upload,
    handoff: handoff,
    offer: offer,
    Uploader: Uploader,
    thumbEl: thumbEl,
    render: render,
    open: function (opener) { return openDialog(opener || null, !!read()); },
    copy: T
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initHeader);
  else initHeader();
  try { document.dispatchEvent(new CustomEvent('ei:logo:ready')); } catch (e) { /* old browser */ }
})();
